export default __webpack_public_path__ + "static/network-2-628a29325eebc9a543a12380e9a79aac.png";